import React from 'react'
import { Popup } from 'antd-mobile'
import '../styles/ProgramModal.css'
import '../styles/EditRecommendationModal.css'

const Field = ({ label, value }) => (
  <div className="workout-field">
    <span className="workout-field-label">{label}</span>
    <span className="workout-field-value">{value ?? '—'}</span>
  </div>
)

const FieldRow = ({ children }) => (
  <div className="workout-field-row">{children}</div>
)

export const resolveFormValue = (record) => {
  const value =
    record.int_value != null
      ? record.int_value
      : record.string_value != null
        ? record.string_value
        : record.text_value != null
          ? record.text_value
          : record.date_value
  return value == null ? '—' : value
}

const QuestionRow = ({ record }) => {
  const value = resolveFormValue(record)
  const displayValue =
    value !== '—' && record.unit_used ? `${value} ${record.unit_used}` : value

  return (
    <div className="bridge-question-row">
      <div className="bridge-question-left">
        <span className="bridge-question-text">{record.question || 'Question'}</span>
        <span className="bridge-question-meta">
          {record.parameter_name || '—'}
        </span>
      </div>
      <span className="bridge-question-value">{displayValue}</span>
    </div>
  )
}

function BridgeFormResultDetailModal({ visible, onClose, formName, records }) {
  if (!records || records.length === 0) return null

  return (
    <Popup
      visible={visible}
      onMaskClick={onClose}
      onClose={onClose}
      position="bottom"
      bodyClassName="modal-popup"
    >
      <div className="modal-content">
        <div className="modal-header-wrapper">
          <div className="modal-header">
            <h2>Form Result Details</h2>
            <button
              onClick={onClose}
              className="modal-close-btn"
              aria-label="Close"
            >
              Close
            </button>
          </div>
        </div>

        <div className="workout-details-container">
          <FieldRow>
            <Field label="Form" value={formName || '—'} />
            <Field
              label="Responses"
              value={records.length}
            />
          </FieldRow>

          {records.map((record, index) => (
            <QuestionRow key={record.id ?? index} record={record} />
          ))}
        </div>
      </div>
    </Popup>
  )
}

export default BridgeFormResultDetailModal
